/**
* @summary - Component that Provides PPM Track functionality
* @autor vengateshwaran k
* @since 2024-05-30
*/
import { Box, Grid, Modal, Typography } from "@mui/material";
import { eachWeekOfInterval, endOfMonth, format, parseISO, startOfMonth } from 'date-fns';
import React, { useEffect, useRef, useState } from 'react';
import PpmPlannerRepository from '../../api/repositories/ppmPlannerRepository';
import { DefaultCard } from "../../assets/styled-components/card";
import CustomAgGrid from "../commoncomponents/CustomAgGrid";
import RefreshExportButtons from '../commoncomponents/RefreshExportButtons';
import SquareBoxRenderer from './SquareBoxRenderer';
import PpmCalendarPdf from "../commoncomponents/PpmCalendarPdf";
import PageLoader from "../commoncomponents/PageLoader";
import { logDOM } from "@testing-library/react";
const ModalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "1500px",
  height: "100%",
  maxHeight: "calc(100% - 64px)",
  bgcolor: "#fff",
  boxShadow: 24,
  borderRadius: "5px",
  p: 4,
  overflowY: "auto",
  overflowX: "hidden",
};

const PpmShowSchedule = ({ workgroup, year, serviceType, facilityId, companyId, allRows, proposedBy, approvedBy }) => {
  const [gridApi, setGridApi] = useState({});

  const [getData, setGetData] = useState([]);
  const [rowData, setRowData] = useState([]);
  const [allRowData, setAllRowData] = useState([]);
  const childRef = useRef(null);
  const [openModal, setOpenModal] = useState(false);
  const [values, setValues] = useState({});
  const [loading, setLoading] = useState(false);
  const [pageLoading, setPageLoading] = useState(false);

  const generateWeeklyColumns = (month, monthname) => {
    const year = new Date().getFullYear();
    const startDate = startOfMonth(new Date(year, month - 1));
    const endDate = endOfMonth(new Date(year, month - 1));
    const weeks = eachWeekOfInterval({ start: startDate, end: endDate }, { weekStartsOn: 1 });
   const ppmservice = serviceType?.value
    return weeks.map((startOfWeek, index) => ({
      
      field: `${monthname}_week${index + 1}`,
      headerName: `${index + 1}W`,
      flex: 2, // Adjust the flex value to increase the width
      minWidth: 100, // Adjust the minWidth value to increase the minimum width
      cellRenderer: SquareBoxRenderer,
      cellRendererParams: { values ,ppmservice},
    
    }));
  };

  const colDefs1 = [
    { field: "assetno", headerName: "Asset No", flex: 1, minWidth: 200, filter: "agTextColumnFilter", },
    { field: "assetdesc", headerName: "Asset Description", flex: 1, minWidth: 200, filter: "agTextColumnFilter", },
    // { field: "workgroup", headerName: "Work Group", flex: 1, minWidth: 200, filter: "agTextColumnFilter", },

    { headerName: 'JAN', children: generateWeeklyColumns(1, 'jan') },
    { headerName: 'FEB', children: generateWeeklyColumns(2, 'feb') },
    { headerName: 'MAR', children: generateWeeklyColumns(3, 'mar') },
    { headerName: 'APR', children: generateWeeklyColumns(4, 'apr') },
    { headerName: 'MAY', children: generateWeeklyColumns(5, 'may') },
    { headerName: 'JUN', children: generateWeeklyColumns(6, 'jun') },
    { headerName: 'JUL', children: generateWeeklyColumns(7, 'jul') },
    { headerName: 'AUG', children: generateWeeklyColumns(8, 'aug') },
    { headerName: 'SEP', children: generateWeeklyColumns(9, 'sep') },
    { headerName: 'OCT', children: generateWeeklyColumns(10, 'oct') },
    { headerName: 'NOV', children: generateWeeklyColumns(11, 'nov') },
    { headerName: 'DEC', children: generateWeeklyColumns(12, 'dec') },
  ];
  const fetchOptions = async () => {
    try {
      setLoading(true);
      let schedule = null;
      if (serviceType?.value === 'FEMS' && allRows?.length > 0) {
        schedule = await PpmPlannerRepository.getPpmShowSchedule(facilityId, workgroup?.id, year?.label);
        setValues(schedule);
        console.log(schedule, "schedule");
    
        if (Array.isArray(schedule?.data) && schedule.data.length > 0) {
            const formattedData = schedule.data.map(item => ({
              ppmservice:serviceType?.value,
                assetno: item.femppmscheduledetails.femassetregister.assetno,
                assetdesc: item.femppmscheduledetails.femassetregister.assetdesc,
                targetdate: item.targetdate,
                week: item.week,
                enddate: item?.femscheduledworkorderheaders?.[0]?.femscheduledwocompletiondetails?.[0]?.enddate || null
            }));
            const result = Object.values(
              formattedData.reduce((acc, { assetno, targetdate, assetdesc, enddate }) => {
                  if (!acc[assetno]) {
                      acc[assetno] = { assetdesc, assetno, targetdates: [], enddates: [], count: 0 };
                  }
          
                  acc[assetno].targetdates.push(targetdate);
                  acc[assetno].count += 1;
          
                  // Push `enddate` into an array instead of trying to push into `null`
                  acc[assetno].enddates.push(enddate);
                  acc[assetno].enddates.sort((a, b) => new Date(a) - new Date(b));
          
                  acc[assetno].targetdates.sort((a, b) => new Date(a) - new Date(b));
          
                  return acc;
              }, {})
          );
          
          // console.log("Final Result:", result);
          
          
          // console.log(result,"result of enddate");
          
    
            setGetData(result);
        }
    }
     else {
        schedule = await PpmPlannerRepository.getBemsPpmShowSchedule(facilityId, workgroup?.id, year?.label);
        setValues(schedule)
        console.log(schedule, "schedule")
        if (schedule?.data?.length > 0) {
          const formattedData = schedule?.data?.map(item => {
            return {
              ppmservice:serviceType?.value,
              assetno: item.bemppmscheduledetails.bemassetregister.assetno,
              assetdesc: item.bemppmscheduledetails.bemassetregister.assetdesc,
              targetdate: item?.targetdate,
              enddate: item?.femscheduledworkorderheaders?.[0]?.femscheduledwocompletiondetails?.[0]?.enddate || null
            };
          });
          // console.log(formattedData,"formattedData")
          const result = Object.values(
            formattedData.reduce((acc, { assetno, targetdate, assetdesc, enddate }) => {
                if (!acc[assetno]) {
                    acc[assetno] = { assetdesc, assetno, targetdates: [], enddates: [], count: 0 };
                }
        
                acc[assetno].targetdates.push(targetdate);
                acc[assetno].count += 1;
        
                // Push `enddate` into an array instead of trying to push into `null`
                acc[assetno].enddates.push(enddate);
                acc[assetno].enddates.sort((a, b) => new Date(a) - new Date(b));
        
                acc[assetno].targetdates.sort((a, b) => new Date(a) - new Date(b));
        
                return acc;
            }, {})
        );
        ;
          setGetData(result);

        }
      }
   
    }
    catch (e) {
      console.log(e);
    }
    // finally {
    //   setLoading(false);
    // }
  }

  useEffect(() => {
 
    fetchOptions();

  }, [])


  useEffect(() => {
    if (serviceType?.value === 'FEMS') {
      if (getData !== null && getData.length > 0 && getData !== undefined) {
        const formattedData = getData?.map(item => {
          const targetDates = item?.targetdates?.map((item) => {
            const date = parseISO(item);
            const formattedDate = format(date, 'yyyy-MM-dd');
            return formattedDate
          });
          return { assetno: item?.assetno, assetdesc: item?.assetdesc, targetDates: targetDates.join(',') };
        });
        setAllRowData(formattedData);
      }

    } else {
      if (getData !== null && getData.length > 0 && getData !== undefined) {
        const formattedData = getData?.map(item => {
      
          const targetDates = item?.targetdates?.map((item) => {
            const date = parseISO(item);
            const formattedDate = format(date, 'yyyy-MM-dd');
            return formattedDate
          });

          return { assetno: item?.assetno, assetdesc: item?.assetdesc, targetDates: targetDates.join(',') };
        });
        setAllRowData(formattedData);
// console.log(allRowData,"rowdata")
      }

    }

  }, [getData])

  const handleDateSubmit = async (inputAssetNo, inputDates, Row) => {
    if (!inputAssetNo || !inputDates) return [];
    const dates = inputDates.split(',')?.map(dateStr => parseISO(dateStr.trim()));
    const today = new Date();

    if (Row?.assetno === inputAssetNo) {
   
      const updatedRow = { ...Row };
    

      dates.forEach(date => {
           const month = date.getMonth() + 1;
        const year = date.getFullYear();
        const startDate = startOfMonth(new Date(year, month - 1));
        const endDate = endOfMonth(new Date(year, month - 1));
        const weeks = eachWeekOfInterval({ start: startDate, end: endDate }, { weekStartsOn: 1 });

        let weekNumber = 0;
        weeks.forEach((weekStart, index) => {
          if (date >= weekStart && date < (index + 1 < weeks.length ? weeks[index + 1] : endDate)) {
            weekNumber = index + 1;
          }
        });

        const color = date > today  ? 'linear-gradient(to right, red 25%, lightcoral 25%)' : 'linear-gradient(to right, green 25%, lightgreen 25%)'; // Determine the color based on date comparison
        updatedRow[`${format(date, 'MMM').toLowerCase()}_week${weekNumber}`] = { date, color };
// Save both date and color
      });

      return updatedRow;
    }

  }

  const fetchData = async () => {
   
    if (allRowData.length===0) return;
    setLoading(true)

    const results = await Promise.all(allRowData.map(async (item) => {
      const updatedRows = await handleDateSubmit(item.assetno, item.targetDates, item);
      return updatedRows;
    }));
    const flattenedResults = results.flat();
    const res = flattenedResults?.map((item) => {
      return { ...item, workgroup: workgroup?.label }

    })
    setRowData(res);
    if (res.length > 0) {
      setLoading(false)
    }

  };


  useEffect(() => {
  
    fetchData();
 
  }, [allRowData]);


  const handleGridRefresh = () => {
    fetchOptions();

  }

  const convertColumns = (inputColumns) => {
    const columns = [];

    inputColumns.forEach(column => {
      // Add assetno and assetdesc fields directly
      if (column.field) {
        columns.push({ field: column.field, header: workgroup?.label, subHeader: column.headerName });
      } else {
        // For months with child weeks, iterate over children
        column.children.forEach(week => {
          columns.push({ field: week.field, header: column.headerName, subHeader: week.headerName });
        });
      }
    });

    return columns;
  };


  const formatWeekData = (data) => {
    return data.map(item => {
      const weekData = Object.keys(item).reduce((acc, key) => {
        if (key.includes('week') && item[key]?.date) {
          const formattedDate = format(new Date(item[key].date), 'dd MMM yyyy - EEE');
          acc[key] = formattedDate;
        } else if (key.includes('week')) {
          acc[key] = ""; // Empty string for missing week data
        }
        return acc;
      }, {});

      return {
        assetno: item.assetno,
        assetdesc: item.assetdesc,
        ...weekData // Add dynamic week fields with formatted date
      };
    });
  };
  const cols = convertColumns(colDefs1)

  // Transform the asset data
  const data = formatWeekData(rowData);

  const handleDownloadPDF = async () => {
    // Open the modal and render the content
    setOpenModal(true);

    // Wait for the modal and component to fully load
    setTimeout(() => {
      if (childRef.current) {
        // Trigger the PDF download method after ensuring the component is loaded
        childRef.current.handleDownloadPDF();
      }

      // Close the modal after the PDF download is initiated
      setTimeout(() => {
        setOpenModal(false);
      }, 1000); // Adjust this timing as needed
    }, 500); // Adjust this timing to ensure the component is fully rendered
  };

  return (
    <>
      <PageLoader open={pageLoading} />
      <DefaultCard>
        <Grid container spacing={2}>
          <Grid container spacing={2} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Grid item xs={12} md={4} sx={{ display: 'flex', justifyContent: 'center', marginTop: '5px' }}>
              <Typography variant='h2'>Today,      {format(new Date(), 'dd MMM, yyyy')}</Typography>
            </Grid>
            <Grid item xs={12} md={2} sx={{ display: 'flex', justifyContent: { xs: 'flex-end', md: 'flex-end' }, marginTop: '10px' }}>
              <Box
                sx={{
                  width: 15, // width of the box in pixels
                  height: 15, // height of the box in pixels
                  backgroundColor: 'green', // green background color
                  marginRight: 1,
                  marginTop: '1px'
                }}
              />
              <span>Completed</span>
            </Grid>
            <Grid item xs={12} md={1} sx={{ display: 'flex', justifyContent: { xs: 'flex-end', md: 'flex-end' }, marginTop: '10px' }}>
              <Box
                sx={{
                  width: 15, // width of the box in pixels
                  height: 15, // height of the box in pixels
                  backgroundColor: 'red', // red background color
                  marginRight: 1,
                  marginTop: '1px'
                }}
              />
              <span>Pending</span>
            </Grid>
            <Grid item xs={12} md={2} sx={{ display: 'flex', justifyContent: 'flex-start', marginBottom: '10px' }}>
              <RefreshExportButtons customPdf={handleDownloadPDF} exportFunction={() => { }} formattedData={data} formattedHeaders={cols} exportData={rowData} title='PPM Show Schedule' ppm={true} refData={gridApi} handleRefresh={handleGridRefresh} />
            </Grid>
          </Grid>

          <Grid item xs={12} md={12}>
            <CustomAgGrid
              ref={gridApi}
              setGridApi={setGridApi}
              rows={rowData}
              isLoading={loading}
              columns={colDefs1}
              disableToolTip={true}
              // disableFilter={true}
              frameworkComponents={{ squareBoxRenderer: SquareBoxRenderer }} // Register the custom cell renderer
              headerLayer={3}
            />
          </Grid>
        </Grid>

        <Modal
          open={openModal}
          sx={
            {
              "& .MuiBackdrop-root": {
                backgroundColor: "transparent",
              },
              top: "-9999px",
              left: "-9999px",
              zIndex: "-1",
            }
          }
        >
          <Box sx={ModalStyle}>
            <PpmCalendarPdf
              ref={childRef}
              year={year?.label}
              workgroup={workgroup?.label}
              proposedby={proposedBy}
              approvedby={approvedBy}
              headers={cols}
              data={data}

            />

          </Box>

        </Modal>
      </DefaultCard>
    </>

  );
}

export default PpmShowSchedule;
